<template>
  <TopGradientBlockLayout class="flex flex-col">
    <template v-slot:top>
      <IncomeSettingsForm/>
    </template>
    <IncomeList class="mb-13 lg:mb-27"
                :list="incomes"
                @editIncome="setEditIncome"/>
    <div class="border-t border-border -mx-12 mt-auto p-12 pb-0">
      <ButtonGrouped @click="$emit('nextStep')">
        <template v-slot:left>{{ $t('finishText') }}</template>
        <template v-slot:right>
          <IconArrow direction="right" class="mr-2 w-4-5 h-4-5"/>
          {{ $t('nextStep') }}
        </template>
      </ButtonGrouped>
    </div>

    <transition name="modal">
      <IncomeSettingsEditModal v-if="!!edit_income"
                               :edit_income="edit_income"
                               @close="edit_income=null"/>
    </transition>
  </TopGradientBlockLayout>
</template>

<script>
import TopGradientBlockLayout from "@/components/layouts/cabinet/TopGradientBlockLayout";
import IncomeSettingsForm from "@/components/cabinet/SpaceSettings/IncomeSettings/IncomeSettingsForm";
import IncomeList from "@/components/cabinet/SpaceSettings/IncomeSettings/IncomeList";
import {mapActions, mapState} from "vuex";
import IncomeSettingsEditModal from "@/components/cabinet/SpaceSettings/IncomeSettings/IncomeSettingsEditModal";
import ButtonGrouped from "@/components/UI/ButtonGrouped";
import IconArrow from "@/components/icons/IconArrow";

export default {
  name: "WizardStep2",
  components: {
    IconArrow,
    ButtonGrouped,
    IncomeSettingsEditModal,
    IncomeList,
    IncomeSettingsForm,
    TopGradientBlockLayout
  },
  data() {
    return {
      edit_income: null,
      openForm: false,
      dataFetched: true
    }
  },
  computed: {
    ...mapState('space/incomes', ['incomes']),
  },
  methods: {
    ...mapActions('space/incomes', ['getIncomes']),
    setEditIncome(val) {
      this.edit_income = val;
    },
    async fetchMainData() {
      try {
        if (this.$store.state.space.incomes.incomes.length === 0) {
          await this.$store.dispatch('space/incomes/getIncomes');
        }
      } catch (e) {
        throw e;
      }
    },
  },
  async created() {
    await this.fetchMainData();
    this.dataFetched = true;
  },
  i18n: {
    messages: {
      en: {
        finishText: 'I added all sources',
        nextStep: 'Step 3'
      },
      ru: {
        finishText: 'Я добавил все источники',
        nextStep: 'Шаг 3'
      }
    }
  }
}
</script>